import React from 'react';
import PropTypes from 'prop-types';
import Icon from "SF/MaterialIcon";
import css from "./HelpPage.scss";
import { isEmptyString } from "utils/text";
import { HelpDeskInformation } from 'utils/types';
import HelpResources from './HelpResources';

const HelpPage = ({ helpPageDetails, deepLinksEnabled, starfishCustomWord }) => {
    // Link to user's default login page. Deep link redirect helps to find the correct login page depending on the tenant's SSO method.
    const footerInfo = deepLinksEnabled ? (
        <div className={css['footer-information']}>
            <div className={css['return']}>
                <Icon icon="launch" aria-hidden="true" />
                <a href='../dl/'>
                    Thanks, Take me to login to {starfishCustomWord}
                </a>
            </div>
        </div>
    ) : null;

    const helpDeskInformation =
        isEmptyString(helpPageDetails.phone) && isEmptyString(helpPageDetails.email) && isEmptyString(helpPageDetails.url)
            ? (
                <p className={css['helpdesk-empty-info']}>
                    {"Your institution has not provided this information yet. Visit your institution's website for technical support."}
                </p>
            ) : (
                <div className={css['helpPage-information']}>
                    <h1>Help Desk Information</h1>
                    <p>Need some assistance? Below you may find provided resources to help you out.</p>
                    <HelpResources helpDeskInformation={helpPageDetails} />
                </div>
        );

    return (
        <>
            <header className={css['helpPage-header']}>
                <h2>{`Help Resources`}</h2>
            </header>
            {helpDeskInformation}
            {footerInfo}
        </>
    );
}

HelpPage.propTypes = {
    helpPageDetails: HelpDeskInformation,
    starfishCustomWord: PropTypes.string,
    deepLinksEnabled: PropTypes.bool
}

export default HelpPage;
